import { H1 } from "common/components/Typography";
import * as React from "react";

interface Props {
  withSpacing?: boolean;
}

export const Title: React.FC<React.PropsWithChildren<Props>> = ({
  withSpacing,
  children,
}) => {
  return <H1 withSpacing={withSpacing}>{children}</H1>;
};
